export default "__VITE_ASSET__DRUz0wnL__"